<template>
  <div class="join-us">
    <h2 class="intro">There's always room for one more...</h2>

    <section 
      class="tos" 
      :class="{ 'user-is-member': isMemberAlready , 'open' : openTOS}"
      @mousemove="handleMouseMove" 
      @pointermove="handleMouseMove" 
      @mouseenter="handleMouseMove"
    >

      <h2>REMOTE VIEWERS CLUB</h2>
      <h3>MEMBERSHIP AGREEMENT AND TERMS OF PARTICIPATION</h3>
      <p>**WHEREAS**, the undersigned individual (hereinafter referred to as "MEMBER," "PSYCHIC ASPIRANT," "THIRD EYE ENTHUSIAST," or "YOU") wishes to join the organization known as the Remote Viewers Club (hereinafter referred to as "THE CLUB," "THE ORGANIZATION," "THE PSYCHIC COLLECTIVE," or "THOSE WHO SEE BEYOND");

**AND WHEREAS**, THE CLUB offers training, community, and support for individuals seeking to develop their extrasensory perception abilities and other arcane practices;

**NOW, THEREFORE**, in consideration of the mutual covenants contained herein, and other good and valuable consideration (both visible and invisible to the naked eye), the parties hereby agree as follows:

### ARTICLE I: DEFINITIONS

1.1 **"Remote Viewing"** shall be defined as the alleged practice of seeking impressions about a distant or unseen target using paranormal means, in particular, extrasensory perception (ESP) or "sensing" with the mind.

1.2 **"Séance"** shall refer to the practice of attempting to communicate with spirits of the dead, whether through mediumship, automatic writing, Ouija boards, or simply asking politely if any entities would like to join the conversation.

1.3 **"Precognition"** shall be defined as the purported ability to perceive future events before they happen, whether through dreams, visions, intuition, or suddenly knowing what your friends will order at a restaurant before they do.

1.4 **"Arcane Practices"** shall encompass all esoteric activities including but not limited to: astral projection, aura reading, psychometry, dowsing, channeling, energy healing, telepathic communication with animals or plants, and locating lost TV remotes through extrasensory means.

1.5 **"Psychic Abilities"** shall refer to any and all paranormal talents including but not limited to: clairvoyance, telepathy, retrocognition, psychokinesis, teleportation, and knowing which streaming service has that movie you want to watch without having to search for it.

1.6 **"Session"** shall refer to any period of time during which MEMBER engages in arcane practices, regardless of whether said MEMBER is actually achieving results or is, in fact, simply staring blankly at a wall.

### ARTICLE II: MEMBERSHIP TERMS

2.1 Membership shall commence upon the signing of this Agreement in blood.

2.2 MEMBER acknowledges that THE CLUB makes no guarantees regarding the development of psychic abilities or mastery of arcane practices, and that results may vary from "absolutely nothing" to "mild coincidences that could be interpreted as evidence of paranormal phenomena" to "successful communication with beings from other planes of existence."

2.3 MEMBER hereby waives the right to request refunds based on lack of psychic development. THE CLUB maintains that failure to develop abilities is due to MEMBER's insufficient spiritual evolution, skepticism, mercury being in retrograde, or temporary disturbances in the ether.

### ARTICLE III: MEMBER CONDUCT AND RESPONSIBILITIES

3.1 MEMBER agrees to participate in all exercises and training protocols as prescribed by THE CLUB, no matter how ridiculous they may appear to the untrained mind or conventional society.

3.2 MEMBER shall maintain a dream journal, meditation log, séance record, precognition prediction ledger, and documentation of all arcane sessions, even if said records consist primarily of drawings resembling children's scribbles or descriptions that could apply to literally any location or entity in this realm or others.

3.3 MEMBER agrees to use any developed psychic abilities and arcane practices at their own discretion, understanding that THE CLUB neither encourages nor discourages any particular application of said abilities. THE CLUB acknowledges that the moral and ethical deployment of mystical powers remains the sole responsibility of the MEMBER.

3.4 MEMBER shall exercise independent judgment when communicating with spirits, peering into the future, manipulating energy fields, or otherwise engaging in activities that may alter the fabric of reality.

### ARTICLE IV: CLUB PROTOCOLS AND PRACTICES

4.1 THE CLUB shall provide MEMBER with various protocols for developing remote viewing abilities, conducting séances, enhancing precognition, and mastering other arcane practices, including but not limited to:
   a) Staring at random photographs while attempting to "sense" their locations
   b) Drawing impressions of hidden objects
   c) Attempting to identify playing cards without looking at them
   d) Communicating with spirits through various mediumship techniques
   e) Documenting precognitive dreams and visions
   f) Attempting to bend spoons with the mind (spoons not provided)
   g) Sending telepathic messages to other MEMBERS (receipt of messages not guaranteed)
   h) Projecting consciousness to other planes of existence
   i) Reading the energy fields of objects, places, or persons

4.2 MEMBER acknowledges that THE CLUB's training techniques are based on a proprietary blend of declassified government research, ancient mystical practices, communications with non-corporeal entities, New Age philosophy, and things we saw in science fiction movies that seemed plausible.

### ARTICLE V: DISCLAIMERS AND LIMITATIONS OF LIABILITY

5.1 THE CLUB expressly disclaims any responsibility for:
   a) Headaches resulting from intense psychic concentration
   b) Vivid dreams that may or may not be prophetic
   c) Sudden urges to purchase crystals, incense, or ceremonial daggers
   d) The development of an annoying habit of saying "I knew that was going to happen" after ordinary events
   e) Friends and family members slowly backing away during conversations
   f) Unexpected spirit visitations following séance activities
   g) Temporal paradoxes resulting from precognitive interference
   h) Interdimensional beings taking up residence in MEMBER's home

5.2 MEMBER assumes all risks associated with remote viewing, séances, precognition, and other arcane practices, including but not limited to: ego inflation, metaphysical confusion, being a topic of concern at family interventions, and unexpected alterations to the space-time continuum.

5.3 THE CLUB makes no warranties, express or implied, that MEMBER will:
   a) Actually develop any psychic abilities whatsoever
   b) Successfully communicate with the deceased
   c) Accurately predict future events
   d) Be able to find lost keys, remote controls, or socks
   e) Avoid traffic by predicting accidents
   f) Save money on cable by psychically viewing premium content
   g) Successfully traverse the astral plane without incident

### ARTICLE VI: CONFIDENTIALITY

6.1 MEMBER agrees to maintain the confidentiality of all CLUB techniques, protocols, and practices, except when attempting to impress others at parties, in which case limited disclosure is permitted if accompanied by a mysterious smile and enigmatic nod.

6.2 THE CLUB reserves the right to deny knowledge of MEMBER should their public claims of psychic ability become embarrassingly grandiose or result in unwanted media attention.

6.3 Information obtained through precognition, remote viewing, or communication with non-corporeal entities may be shared at MEMBER's discretion, with the understanding that THE CLUB bears no responsibility for the consequences of such disclosure.

### ARTICLE VII: TERMINATION

7.1 This Agreement may be terminated by either party, provided that:
   a) MEMBER provides written notice; or
   b) THE CLUB senses MEMBER's desire to leave through psychic means; or
   c) A spirit guide conveys MEMBER's intention to depart during a séance.

7.2 Upon termination, MEMBER agrees to cease representing themselves as affiliated with THE CLUB, but may continue personal psychic development and arcane practices in the privacy of their own home, preferably with the blinds drawn.

### ARTICLE VIII: GOVERNING LAW

8.1 This Agreement shall be governed by the laws of physical reality, except where superseded by the laws of metaphysics, quantum uncertainty, or whatever paradigm MEMBER believes in most strongly at the time of dispute.

8.2 Any disputes arising from this Agreement shall be settled through conventional legal means, as THE CLUB acknowledges that while psychic arbitration would be preferable, it remains impractical for non-initiates.

8.3 In matters involving spirits, precognitive events, or other extradimensional phenomena, the ruling of the Council of Elders (a group of THE CLUB's most advanced practitioners) shall be considered binding in all realms of existence.

IN WITNESS WHEREOF, the parties have executed this Agreement as of the date first written above, or as of the date they psychically became aware of it, whichever came first.

*Note: By signing this document, MEMBER confirms they have read and understood all terms, or have at least attempted to perceive them psychically. This Agreement is binding in this dimension and all parallel realities.*</p>
    
      <CandleAnimation 
        class="candle-mover" 
        :isMemberAlready="isMemberAlready"
      />
    </section>

    <section class="members-toggle">
      <button 
        v-show="isMemberAlready"
        class="tos-handler"
        @click="handleTOSToggle">
        {{ openTOS ? 'Close Terms you already agreed to' : 'Review Terms - No Backsies!'}}
      </button>
    </section>

    <section class="signature" v-show="!isMemberAlready">
      <h3>- Sign Here When Ready -</h3>
      <SignaturePad 
        bloodColor="#8B0000"
      />
    </section>

    <section>
      <button v-show="!showMembershipRoll" @click="enableShowMembershipRoll">Show Roll</button>
      <button v-show="showMembershipRoll" @click="showMembershipRoll = false">Hide Roll</button>
    </section>

    <section v-if="isMemberAlready || showMembershipRoll" class="signature-gallery">
      <SignatureGallery />
    </section>
  </div>
</template>

<script>
import SignaturePad from './SignaturePad'
import SignatureGallery from './SignatureGallery'
import CandleAnimation from './animations/CandleAnimation'
import { eventBus } from '../EventBus'

export default {
  name: 'join-us',
  components: {
    SignaturePad,
    SignatureGallery,
    CandleAnimation
  },
  methods: {
    handleMouseMove(e) {
      const root = document.documentElement;
      let x = e.offsetX;
      let y = e.offsetY;
  
      root.style.setProperty('--mouse-x', `${x}px`);
      root.style.setProperty('--mouse-y', `${y}px`);
    },
    checkIfSigSaved() {
      this.isMemberAlready = localStorage.getItem('rvc-joined') || false
    },
    confirmSigSaved() {
      this.isMemberAlready = true;
    },
    handleTOSToggle() {
      this.openTOS = !this.openTOS;
    },
    enableShowMembershipRoll() {
      this.showMembershipRoll = true;
    }
  },
  data() {
    return {
      isMemberAlready: false,
      openTOS: false,
      showMembershipRoll: false,
    }
  },
  mounted() {
    this.isMemberAlready = localStorage.getItem('rvc-joined') || false

    eventBus.on('confirmSigSaved', this.confirmSigSaved)
  },
  updated() {
    this.isMemberAlready = localStorage.getItem('rvc-joined') || false
  }
}
</script>

<style>
:root {
  --color-1: rgb(205 205 155 / 1);
  --color-2: rgb(0 0 0 / 0);
  --mouse-x: 10%;
  --mouse-y: 15em;
	--size: 15em;
}

.tos {
  background-color: rgba(0,0,0,0.8);
  width: 90%;
  margin: 0 auto;
  padding: 2rem 3rem;
  cursor: grabbing;
  max-width: 1200px;
  position: relative;
  transition: all 2s;
} 

.tos p {
  background: radial-gradient(var(--size) var(--size) at var(--mouse-x) var(--mouse-y),  
    var(--color-1) 0%,
    var(--color-2) 99%
  );
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
	user-select: none;
	text-align: left;
  animation: flameFlicker 4s infinite alternate;
}

.tos h2,
.tos h3 {
  margin: 0;
  padding: 0;
}

.tos h3 {
  font-weight: 200;
  font-size: 1.25rem;
}

.tos.user-is-member {
  max-height: 20rem;
  text-overflow: ellipsis;
  overflow: hidden;
}

.tos.user-is-member.open {
  max-height: 100rem;
}

.signature {
  margin: 0 auto;
  background-color: rgba(0,0,0,0.8);
  padding: 2rem;
  max-width: 500px;
}

.signature h3 {
  margin: 0;
  padding: 0;
}

.candle-mover {
  position: absolute;
  left: var(--mouse-x);
  top: calc(var(--mouse-y) + 20px );
  width: 80px;
}

.members-toggle {
  display: flex;
  align-content: center;
  margin-top: -1rem;
  position: relative;
  z-index: 10;
}

.tos-handler {
  margin: 0 auto;
  background: red;
  color: white;
  border-radius: 10px;
  padding: 0.5rem 0.75rem;
  border: none;
  width: 450px;
  text-transform: uppercase;
  font-size: 120%;
  border: 5px solid rgba(0,0,0,0.8);
  opacity: 0.85;
  transform: scale(0.95);
  transition: all 0.5s;
  font-weight: bold;
}

.tos-handler:hover {
  cursor: pointer;
  opacity: 1;
  transform: scale(1);
}
</style>